import type { UserManager } from 'oidc-client-ts';
import { BrowserRouter, Route, Routes } from 'react-router';

import { ApiProvider } from './api/api.js';
import { AuthProvider } from './auth/AuthProvider.js';
import { Callback, NoAccess, RequireSignIn, SignedOut, SignInFailed } from './auth/pages.js';
import { CALLBACK_PATH } from './auth/session.js';
import type { ConsoleConfig } from './config.js';
import { I18nProvider } from './i18n/I18n.js';
import { SchoolGate } from './school/SchoolGate.js';
import { Shell } from './shell/Shell.js';

export function App({ config, manager }: { config: ConsoleConfig; manager: UserManager }) {
  return (
    <BrowserRouter>
      <I18nProvider>
        <AuthProvider manager={manager}>
          <ApiProvider config={config}>
            <Routes>
              <Route path={CALLBACK_PATH} element={<Callback />} />
              <Route path="/signed-out" element={<SignedOut />} />
              <Route path="/sign-in-failed" element={<SignInFailed />} />
              <Route
                path="/no-access"
                element={
                  <RequireSignIn>
                    <NoAccess />
                  </RequireSignIn>
                }
              />
              <Route
                path="*"
                element={
                  <RequireSignIn>
                    <SchoolGate>
                      <Shell />
                    </SchoolGate>
                  </RequireSignIn>
                }
              />
            </Routes>
          </ApiProvider>
        </AuthProvider>
      </I18nProvider>
    </BrowserRouter>
  );
}
